import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

if (typeof window !== 'undefined') {
    window.history.scrollRestoration = 'manual';
}

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    }, [pathname]);

    return null;
}
